import { render } from "./customsetting.vue?vue&type=template&id=48f3bf90&scoped=true"
import script from "./customsetting.vue?vue&type=script&lang=js"
export * from "./customsetting.vue?vue&type=script&lang=js"

import "./customsetting.vue?vue&type=style&index=0&id=48f3bf90&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f3bf90"]])

export default __exports__